import {
  SET_SELECTED_INVENTORY_ITEMS,
  CLEAR_SELECTED_INVENTORY_ITEMS,
  TOGGLE_INVENTORY_ITEM
} from "../constants";

const initialState = {
  selectedItems: {},
  totalSelected: 0
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_INVENTORY_ITEMS:
      const newItems = {
        ...state.selectedItems,
        ...action.payload
      };
      
      return {
        ...state,
        selectedItems: newItems,
        totalSelected: Object.keys(newItems).length
      };
    
    case CLEAR_SELECTED_INVENTORY_ITEMS:
      return initialState;
    
    case TOGGLE_INVENTORY_ITEM:
      const { id, selected, sendQuantity = 1, variants, ...otherData } = action.payload;
      const updatedItems = { ...state.selectedItems };
      
      if (selected !== false) { // If selected is true or undefined (for updates)
        updatedItems[id] = {
          ...state.selectedItems[id], // Preserve existing data
          selected: true,
          sendQuantity,
          variants: variants || state.selectedItems[id]?.variants,
          ...otherData
        };
      } else {
        delete updatedItems[id];
      }

      return {
        ...state,
        selectedItems: updatedItems,
        totalSelected: Object.keys(updatedItems).length
      };

    default:
      return state;
  }
}
